export default "__VITE_ASSET__Cme3I6np__"